import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * The one styling for a selected nav-ish item (active tab, segmented option):
 * primary-tinted. Use this instead of hand-rolling bg-accent variants so
 * active states stay consistent app-wide.
 */
export const navActiveClass =
  "bg-primary/10 text-primary hover:bg-primary/15 hover:text-primary"
